export default "<div class=\"h-100\">\r\n    <img src=\"../assets/img/Loading.gif\" alt=\"header-icon\">\r\n</div>\r\n"